<template>
    <div class="dateTimeRangeSelection">
        <div class="entryRow">
            <div class="fieldLabel">From date/time</div>
            <limited-date-picker v-model="dateFrom" :sync-require-before="dateTo"></limited-date-picker>
            <time-input-field v-model="dateFrom"></time-input-field>
        </div>

        <div class="entryRow">
            <div class="fieldLabel">To date/time</div>
            <limited-date-picker v-model="dateTo" :sync-require-after="dateFrom"></limited-date-picker>
            <time-input-field v-model="dateTo"></time-input-field>
        </div>
    </div>
</template>

<script>
import LimitedDatePicker from './LimitedDatePicker';
import TimeInputField from './TimeInputField';

export default {
    name: 'DateTimeRangeSelection',

    components: {
        LimitedDatePicker,
        TimeInputField
    },

    model: {
        prop: 'outerModel'
    },

    props: {
        outerModel: {
            type: Object,
            required: true,
            validator(value) {
                return value.from instanceof Date && value.to instanceof Date;
            }
        }
    },

    computed: {
        dateFrom: {
            get() {
                return this.outerModel.from;
            },
            set(from) {
                this.$emit('input', Object.assign({}, this.outerModel, { from }));
            }
        },

        dateTo: {
            get() {
                return this.outerModel.to;
            },
            set(to) {
                this.$emit('input', Object.assign({}, this.outerModel, { to }));
            }
        }
    }
};
</script>

<style lang="scss">
.dateTimeRangeSelection {
    .entryRow {
        display: flex;
        align-items: center;

        &:first-child {
            margin-bottom: 10px;
        }

        .fieldLabel {
            font-weight: bold;
            width: 140px;
        }

        .limitedDatePicker {
            margin-right: 15px;
        }
    }
}
</style>
